// extracted by mini-css-extract-plugin
module.exports = {"statsContainer":"styles_statsContainer__4sheE","stats":"styles_stats__1XmKB"};